import {ActionIcon, Button, Paper, Select, TextInput} from "@mantine/core";
import {PlusIcon, TrashIcon} from "@phosphor-icons/react";
import {useState, useEffect, useMemo, useCallback, useContext} from 'react'
import withRouteErrorBoundary from "../../../components/ErrorBoundary/withRouteErrorBoundary.tsx";
import {Col, Row} from "../../../components/Flex/Flex";
import LoaderScreen from "../../../components/Loader/LoaderScreen";
import MessageContext from "../../../context/MessageContext";
import api from "../../../utils/api";



function ManageAllowlist ({faction}) {
    const {success, error} = useContext(MessageContext);
    const [listUsers, setListUsers] = useState([]);
    const [listFactions, setListFactions] = useState([]);
    const [factions, setFactions] = useState([]);


    const [selectedFaction, setSelectedFaction] = useState(null);
    const [user, setUser] = useState('');

    const [loadingFactions, setLoadingFactions] = useState(true);
    const [loadingList, setLoadingList] = useState(true);

    useEffect(() => {
        api.get('/data/factions').then(res => {
            setFactions(res.data.sort((a,b) => a.name.localeCompare(b.name)));
            setLoadingFactions(false);
        })
    }, []);


    useEffect(() => {
        setLoadingList(true);
        api.get('/bh/manage/allowlist/'+faction.id).then(res => {
            setListFactions(res.data.factions);
            setListUsers(res.data.users);
            setLoadingList(false);
        })
    }, [faction]);


    const addUser = () => {
        api.post('/bh/manage/allowlist/'+faction.id+'/user', {user}).then(res => {
            setListUsers(prev => {
                if(!prev.find(u => u.id === res.data.id)) {
                    return [...prev, {id: res.data.id, name: user}]
                }
                return prev;
            });
            setUser('');
            success('Success', user+' has been added to the list for private access');
        }).catch(err => {
            if(err.response.data && err.response.data.message){
                error('Error', err.response.data.message);
            }
        });
    }
    const addFaction = () => {
        api.post('/bh/manage/allowlist/'+faction.id+'/faction', {faction: selectedFaction}).then(() => {
            setListFactions(prev => {
                if(!prev.includes(selectedFaction)) {
                    return [...prev, selectedFaction];
                }
                return prev;
            });
            setSelectedFaction(null);
            success('Success','The faction has been added to the list for private access');
        });
    }

    const onDelete = useCallback(id => {
        api.delete('/bh/manage/allowlist/'+faction.id+'/'+id).then(() => {
            if(id.substring(0, 3) === '20:') {
                setListFactions(prev => prev.filter(f => f !== id));
            } else {
                setListUsers(prev => prev.filter(u => u.id !== id));
            }
        })
    }, [faction.id]);


    const factionSelectData = useMemo(() => {
        return factions.map(f => ({value: f.id, label: f.name}));
    }, [factions]);

    return (
        <div>
            {loadingFactions || loadingList ? <LoaderScreen message="Loading data" /> : null}
            <Paper>
                <h4>Factions</h4>
                <FactionRow record={faction.id} factions={factions} onDelete={null} />
                {listFactions.map(f => <FactionRow key={f} record={f} factions={factions} onDelete={onDelete} />)}
                <h4>Users</h4>
                {listUsers.map(u => <UserRow key={u.id} record={u} onDelete={onDelete} />)}
            </Paper>
            <Paper>
                <h4>Add Faction</h4>
                <Row>
                    <Col>
                        <Select
                            data={factionSelectData}
                            value={selectedFaction}
                            onChange={v => setSelectedFaction(v)}
                            searchable
                        />
                    </Col>
                    <Col>
                        <Button leftSection={<PlusIcon size={16}/>} onClick={addFaction}>Add Faction</Button>
                    </Col>
                </Row>


                <h4>Add Character</h4>
                <Row>
                    <Col>
                        <TextInput value={user} onChange={e => setUser(e.target.value)} />
                    </Col>
                    <Col>
                        <Button leftSection={<PlusIcon size={16}/>} onClick={addUser}>Add Character</Button>
                    </Col>
                </Row>
            </Paper>

        </div>
    )
}

const FactionRow = ({record, factions, onDelete}) => {
    let f = factions.find(f => f.id === record);
    return (
        <Row align="center" mb={1}>
            <Col><ActionIcon onClick={() => onDelete(record)} disabled={onDelete === null}><TrashIcon size={16}/></ActionIcon></Col>
            <Col>{f?.name}</Col>
        </Row>
    )

}
const UserRow = ({record, onDelete}) => {
    return (
        <Row align="center" mb={1}>
            <Col><ActionIcon onClick={() => onDelete(record.id)} ><TrashIcon size={16}/></ActionIcon></Col>
            <Col>{record.name}</Col>
        </Row>
    )
}

export default withRouteErrorBoundary(ManageAllowlist);
